/**
 * Signal Quality — per-signal outcome metrics from GET /api/leads/signal-quality
 * (Issue 45 loop). Listed-w/-agent rate among connects is false-positive
 * evidence for the scoring flags; weight changes stay manual (leadScoring.js).
 */
import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const pct = (r) => (r === null || r === undefined ? '—' : `${Math.round(r * 100)}%`);
const listedColor = (r) => {
  if (r === null || r === undefined) return undefined;
  if (r >= 0.35) return 'var(--status-error)';
  if (r >= 0.20) return 'var(--status-warning)';
  return undefined;
};

export default function SignalQualityView() {
  const { authFetch } = useAuth();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    authFetch(`${API_BASE}/api/leads/signal-quality`)
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((d) => setRows(d.success && Array.isArray(d.data) ? d.data : []))
      .catch(() => setRows([]));
  }, [authFetch]);

  if (rows === null) return <div className="ws-pulse">Loading…</div>;
  if (rows.length === 0) return (
    <div className="sol-empty">
      <h3>Signal quality unavailable</h3>
      <p>Nothing to show yet — try again shortly.</p>
    </div>
  );

  const flagged = rows.filter((r) => r.recommendation);

  return (
    <div>
      <p className="ws-empty">
        Each row is one scoring signal. “Listed” = share of connects reporting an active
        listing — false-positive evidence for the flag. Rates need connects to mean anything;
        “Progressed” counts current pipeline state only.
      </p>
      {flagged.length > 0 && (
        <p className="signal-quality-flag-note">
          {flagged.map((r) => `${r.label}: ${r.recommendation}`).join(' · ')}
        </p>
      )}
      <div className="signal-quality-table-scroll">
        <div className="ws-table signal-quality-table">
          <div className="ws-row ws-row--head ws-row--grid">
            <span>Signal</span><span>Weight</span><span>Cohort</span><span>Attempted</span>
            <span>Connects</span><span>Listed</span><span>DNC</span><span>Interested</span><span>Progressed</span>
          </div>
          {rows.map((r) => (
            <div key={r.signal} className="ws-row ws-row--grid">
              <span>{r.label}</span>
              <span>{r.weight}</span>
              <span>{r.cohort}</span>
              <span>{r.attempted}</span>
              <span>{r.connects}</span>
              <span style={{ color: listedColor(r.listedRate) }}>{pct(r.listedRate)}</span>
              <span>{pct(r.dncRate)}</span>
              <span>{pct(r.interestedRate)}</span>
              <span>{r.progressed}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
